import axios from "@/libs/api.request.js";

// 微信小游戏企微承接 -- 领取活动礼包码
export const drawActivityReward = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/drawReward`,
    data,
    method: "post",
    requireToken: true
  });
};

// 微信小游戏企微承接 -- 推送活动首页
export const getActivityDetail = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/activityHome`,
    data,
    method: "post",
    requireToken: true
  });
};

// 微信小游戏企微承接 -- 绑定openid
export const bandUserOpenid = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/bindWechat`,
    data,
    method: "post",
    requireToken: true
  });
};